<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'OrganizationRoles',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Роли организации',
        canEdit: true,
        apiRoute: 'nsiorganizationrole',
        cardName: 'OrganizationRoleCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
